// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M15.4142 1H3V23H14.8464C13.4127 21.8077 12.5 20.0104 12.5 18C12.5 14.4101 15.4101 11.5 19 11.5C19.6978 11.5 20.3699 11.61 21 11.8135V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M20.0001 13V20.1092L22.5082 17.6297L23.9143 19.0519L19.0001 23.9103L14.0859 19.0519L15.492 17.6297L18.0001 20.1092V13H20.0001Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-file-download-filled')
export default class FileDownloadFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-download-filled',
    }
  }
}
